"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Api = exports.HttpClient = exports.FecContentType = exports.ServiceFlagType = exports.AccountIdentifierType = exports.PhoneNumberType = exports.ProfileAction = void 0;
var ProfileAction;
(function (ProfileAction) {
    ProfileAction["CREATED"] = "CREATED";
    ProfileAction["UPDATED"] = "UPDATED";
    ProfileAction["DELETED"] = "DELETED";
    ProfileAction["TOUCHED"] = "TOUCHED";
    ProfileAction["ACCOUNT_IDENTIFIER_ADDED"] = "ACCOUNT_IDENTIFIER_ADDED";
    ProfileAction["ACCOUNT_IDENTIFIER_UPDATED"] = "ACCOUNT_IDENTIFIER_UPDATED";
    ProfileAction["ACCOUNT_IDENTIFIER_REMOVED"] = "ACCOUNT_IDENTIFIER_REMOVED";
    ProfileAction["ACCOUNT_IDENTIFIERS_BULK_ADDED"] = "ACCOUNT_IDENTIFIERS_BULK_ADDED";
    ProfileAction["ADDRESS_ADDED"] = "ADDRESS_ADDED";
    ProfileAction["ADDRESS_UPDATED"] = "ADDRESS_UPDATED";
    ProfileAction["ADDRESS_REMOVED"] = "ADDRESS_REMOVED";
    ProfileAction["COMMUNICATION_PREFERENCES_UPDATED"] = "COMMUNICATION_PREFERENCES_UPDATED";
    ProfileAction["DATE_OF_BIRTH_UPDATED"] = "DATE_OF_BIRTH_UPDATED";
    ProfileAction["EMAIL_ADDED"] = "EMAIL_ADDED";
    ProfileAction["EMAIL_UPDATED"] = "EMAIL_UPDATED";
    ProfileAction["EMAIL_REMOVED"] = "EMAIL_REMOVED";
    ProfileAction["EMPLOYEE_ID_UPDATED"] = "EMPLOYEE_ID_UPDATED";
    ProfileAction["LOCALE_UPDATED"] = "LOCALE_UPDATED";
    ProfileAction["MARKETING_OPT_IN_UPDATED"] = "MARKETING_OPT_IN_UPDATED";
    ProfileAction["SMS_OPT_IN_UPDATED"] = "SMS_OPT_IN_UPDATED";
    ProfileAction["NAME_UPDATED"] = "NAME_UPDATED";
    ProfileAction["NATIONAL_IDENTIFIER_UPDATED"] = "NATIONAL_IDENTIFIER_UPDATED";
    ProfileAction["PHONE_NUMBER_ADDED"] = "PHONE_NUMBER_ADDED";
    ProfileAction["PHONE_NUMBER_UPDATED"] = "PHONE_NUMBER_UPDATED";
    ProfileAction["PHONE_NUMBER_REMOVED"] = "PHONE_NUMBER_REMOVED";
    ProfileAction["SERVICE_FLAG_ADDED"] = "SERVICE_FLAG_ADDED";
    ProfileAction["SERVICE_FLAG_REMOVED"] = "SERVICE_FLAG_REMOVED";
    ProfileAction["TCPA_UPDATED"] = "TCPA_UPDATED";
    ProfileAction["TERMS_OF_SERVICE_UPDATED"] = "TERMS_OF_SERVICE_UPDATED";
    ProfileAction["PREFERRED_NAME_UPDATED"] = "PREFERRED_NAME_UPDATED";
    ProfileAction["TITLE_UPDATED"] = "TITLE_UPDATED";
    ProfileAction["PRONOUNS_UPDATED"] = "PRONOUNS_UPDATED";
    ProfileAction["REDACTED_PER_REQUEST"] = "REDACTED_PER_REQUEST";
})(ProfileAction = exports.ProfileAction || (exports.ProfileAction = {}));
var PhoneNumberType;
(function (PhoneNumberType) {
    PhoneNumberType["Home"] = "home";
    PhoneNumberType["Cell"] = "cell";
    PhoneNumberType["Work"] = "work";
})(PhoneNumberType = exports.PhoneNumberType || (exports.PhoneNumberType = {}));
var AccountIdentifierType;
(function (AccountIdentifierType) {
    AccountIdentifierType["Member"] = "member";
    AccountIdentifierType["Associate"] = "associate";
})(AccountIdentifierType = exports.AccountIdentifierType || (exports.AccountIdentifierType = {}));
var ServiceFlagType;
(function (ServiceFlagType) {
    ServiceFlagType["Blind"] = "blind";
    ServiceFlagType["Deaf"] = "deaf";
    ServiceFlagType["SpecialNeeds"] = "specialNeeds";
    ServiceFlagType["FullTimeStudent"] = "fullTimeStudent";
    ServiceFlagType["ResidesWithPrimary"] = "residesWithPrimary";
})(ServiceFlagType = exports.ServiceFlagType || (exports.ServiceFlagType = {}));
const axios_1 = __importDefault(require("axios"));
const utils_1 = require("../../utils");
var FecContentType;
(function (FecContentType) {
    FecContentType["Json"] = "application/json";
    FecContentType["FormData"] = "multipart/form-data";
    FecContentType["UrlEncoded"] = "application/x-www-form-urlencoded";
})(FecContentType = exports.FecContentType || (exports.FecContentType = {}));
class HttpClient {
    constructor(_a = {}) {
        var { securityWorker, secure, format } = _a, axiosConfig = __rest(_a, ["securityWorker", "secure", "format"]);
        this.securityData = null;
        this.setSecurityData = (data) => {
            this.securityData = data;
        };
        this.request = (_b) => __awaiter(this, void 0, void 0, function* () {
            var { secure, path, type, query, format, body } = _b, params = __rest(_b, ["secure", "path", "type", "query", "format", "body"]);
            const secureParams = ((typeof secure === 'boolean' ? secure : this.secure) &&
                this.securityWorker &&
                (yield this.securityWorker(this.securityData))) ||
                {};
            const requestParams = this.mergeRequestParams(params, secureParams);
            const responseFormat = (format && this.format) || void 0;
            if (type === FecContentType.FormData && body && body !== null && typeof body === 'object') {
                requestParams.headers.common = { Accept: '*/*' };
                requestParams.headers.post = {};
                requestParams.headers.put = {};
                body = this.createFormData(body);
            }
            return this.instance.request(Object.assign(Object.assign({}, requestParams), { headers: Object.assign(Object.assign({}, (type && type !== FecContentType.FormData ? { 'Content-Type': type } : {})), (requestParams.headers || {})), params: query, responseType: responseFormat, data: body, url: path }));
        });
        this.instance = axios_1.default.create(Object.assign(Object.assign({}, axiosConfig), { baseURL: utils_1.Environment.getEnvironmentUrl(axiosConfig.baseURL || 'https://profiles.api.legalshield.com'), validateStatus: (status) => {
                return status >= 200 && status < 500;
            } }));
        this.secure = secure;
        this.format = format;
        this.securityWorker = securityWorker;
    }
    mergeRequestParams(params1, params2) {
        return Object.assign(Object.assign(Object.assign(Object.assign({}, this.instance.defaults), params1), (params2 || {})), { headers: Object.assign(Object.assign(Object.assign({}, (this.instance.defaults.headers || {})), (params1.headers || {})), ((params2 && params2.headers) || {})) });
    }
    createFormData(input) {
        return Object.keys(input || {}).reduce((formData, key) => {
            const property = input[key];
            formData.append(key, property instanceof Blob
                ? property
                : typeof property === 'object' && property !== null
                    ? JSON.stringify(property)
                    : `${property}`);
            return formData;
        }, new FormData());
    }
}
exports.HttpClient = HttpClient;
/**
 * @title Profile API
 * @version v1
 * @baseUrl https://profiles.api.legalshield.com
 */
class Api extends HttpClient {
    constructor() {
        super(...arguments);
        this.v1 = {
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name ProfilesJournalAll
             * @summary Machine JWT Only
             * @request GET:/v1/profiles/journal
             * @secure
             */
            profilesJournalAll: (query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/journal`, method: 'GET', query: query, secure: true, format: 'json' }, params)),
            /**
             * @description The journal is for internal use only
             *
             * @tags Journal
             * @name ProfilesJournal
             * @summary Machine JWT Only
             * @request GET:/v1/profiles/journal/maxClock
             * @secure
             */
            profilesJournal: (params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/journal/maxClock`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags BulkProfiles
             * @name BulkProfilesGetThinProfileInformationForList
             * @request POST:/v1/profiles
             * @secure
             */
            bulkProfilesGetThinProfileInformationForList: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesFindByIdentityId
             * @request GET:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesFindByIdentityId: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'GET', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesCreateProfile
             * @request POST:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesCreateProfile: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesUpdateProfile
             * @request PUT:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesUpdateProfile: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'PUT', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesRemoveProfile
             * @request DELETE:/v1/identities/{identityId}/profile
             * @secure
             */
            profilesRemoveProfile: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile`, method: 'DELETE', secure: true }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesTouchProfile
             * @request POST:/v1/identities/{identityId}/profile/touch
             * @secure
             */
            profilesTouchProfile: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/touch`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Profiles
             * @name ProfilesRedactPersonalInformation
             * @request POST:/v1/identities/{identityId}/profile/redactPersonalInformation
             * @secure
             */
            profilesRedactPersonalInformation: (identityId, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/redactPersonalInformation`, method: 'POST', secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Search
             * @name SearchSearchProfiles
             * @request POST:/v1/profiles/search
             * @secure
             */
            searchSearchProfiles: (data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profiles/search`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierAddAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/addAccountIdentifier
             * @secure
             */
            accountIdentifierAddAccountIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addAccountIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierUpdateAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/updateAccountIdentifier
             * @secure
             */
            accountIdentifierUpdateAccountIdentifier: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateAccountIdentifier`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierRemoveAccountIdentifier
             * @request POST:/v1/identities/{identityId}/profile/removeAccountIdentifier
             * @secure
             */
            accountIdentifierRemoveAccountIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeAccountIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags AccountIdentifier
             * @name AccountIdentifierBulkAddAccountIdentifiers
             * @request POST:/v1/identities/{identityId}/profile/bulkAddAccountIdentifiers
             * @secure
             */
            accountIdentifierBulkAddAccountIdentifiers: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/bulkAddAccountIdentifiers`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressAddAddress
             * @request POST:/v1/identities/{identityId}/profile/addAddress
             * @secure
             */
            addressAddAddress: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressUpdateAddress
             * @request POST:/v1/identities/{identityId}/profile/updateAddress
             * @secure
             */
            addressUpdateAddress: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateAddress`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Address
             * @name AddressRemoveAddress
             * @request POST:/v1/identities/{identityId}/profile/removeAddress
             * @secure
             */
            addressRemoveAddress: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeAddress`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreferences
             * @request POST:/v1/identities/{identityId}/profile/communicationPreferences
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreferences: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/communicationPreferences`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreference
             * @request POST:/v1/identities/{identityId}/profile/communicationPreferences/{communicationPreference}
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreference: (identityId, communicationPreference, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/communicationPreferences/${communicationPreference}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags CommunicationPreferences
             * @name CommunicationPreferencesUpdateCommunicationPreferenceByEmail
             * @request POST:/v1/profile/{emailAddress}/communicationPreferences/{communicationPreference}
             * @secure
             */
            communicationPreferencesUpdateCommunicationPreferenceByEmail: (emailAddress, communicationPreference, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/profile/${emailAddress}/communicationPreferences/${communicationPreference}`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags DateOfBirth
             * @name DateOfBirthUpdateDateOfBirth
             * @request POST:/v1/identities/{identityId}/profile/updateDateOfBirth
             * @secure
             */
            dateOfBirthUpdateDateOfBirth: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateDateOfBirth`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailAddEmail
             * @request POST:/v1/identities/{identityId}/profile/addEmail
             * @secure
             */
            emailAddEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailUpdateEmail
             * @request POST:/v1/identities/{identityId}/profile/updateEmail
             * @secure
             */
            emailUpdateEmail: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateEmail`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Email
             * @name EmailRemoveEmail
             * @request POST:/v1/identities/{identityId}/profile/removeEmail
             * @secure
             */
            emailRemoveEmail: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeEmail`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags EmployeeId
             * @name EmployeeIdUpdateEmployeeId
             * @request POST:/v1/identities/{identityId}/profile/updateEmployeeId
             * @secure
             */
            employeeIdUpdateEmployeeId: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateEmployeeId`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Locale
             * @name LocaleUpdateLocale
             * @request POST:/v1/identities/{identityId}/profile/updateLocale
             * @secure
             */
            localeUpdateLocale: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateLocale`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingPreferences
             * @name MarketingPreferencesMarketingOptIn
             * @request POST:/v1/identities/{identityId}/profile/marketingOptIn
             * @secure
             */
            marketingPreferencesMarketingOptIn: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/marketingOptIn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags MarketingPreferences
             * @name MarketingPreferencesSmsOptIn
             * @request POST:/v1/identities/{identityId}/profile/smsOptIn
             * @secure
             */
            marketingPreferencesSmsOptIn: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/smsOptIn`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Name
             * @name NameUpdateName
             * @request POST:/v1/identities/{identityId}/profile/updateName
             * @secure
             */
            nameUpdateName: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags NationalIdentifier
             * @name NationalIdentifierUpdateNationalIdentifier
             * @request POST:/v1/identities/{identityId}/profile/updateNationalIdentifier
             * @secure
             */
            nationalIdentifierUpdateNationalIdentifier: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateNationalIdentifier`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberAddPhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/addPhoneNumber
             * @secure
             */
            phoneNumberAddPhoneNumber: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addPhoneNumber`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberUpdatePhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/updatePhoneNumber
             * @secure
             */
            phoneNumberUpdatePhoneNumber: (identityId, query, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePhoneNumber`, method: 'POST', query: query, body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PhoneNumber
             * @name PhoneNumberRemovePhoneNumber
             * @request POST:/v1/identities/{identityId}/profile/removePhoneNumber
             * @secure
             */
            phoneNumberRemovePhoneNumber: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removePhoneNumber`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags PreferredName
             * @name PreferredNameUpdatePreferredName
             * @request POST:/v1/identities/{identityId}/profile/updatePreferredName
             * @secure
             */
            preferredNameUpdatePreferredName: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePreferredName`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Pronouns
             * @name PronounsUpdatePronouns
             * @request POST:/v1/identities/{identityId}/profile/updatePronouns
             * @secure
             */
            pronounsUpdatePronouns: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updatePronouns`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceFlags
             * @name ServiceFlagsAddServiceFlag
             * @request POST:/v1/identities/{identityId}/profile/addServiceFlag
             * @secure
             */
            serviceFlagsAddServiceFlag: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/addServiceFlag`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags ServiceFlags
             * @name ServiceFlagsRemoveServiceFlag
             * @request POST:/v1/identities/{identityId}/profile/removeServiceFlag
             * @secure
             */
            serviceFlagsRemoveServiceFlag: (identityId, query, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/removeServiceFlag`, method: 'POST', query: query, secure: true, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TCPA
             * @name TcpaUpdateTcpa
             * @request POST:/v1/identities/{identityId}/profile/tcpa
             * @secure
             */
            tcpaUpdateTcpa: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/tcpa`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags TermsOfService
             * @name TermsOfServiceUpdateTermsOfService
             * @request POST:/v1/identities/{identityId}/profile/updateTermsOfService
             * @secure
             */
            termsOfServiceUpdateTermsOfService: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateTermsOfService`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
            /**
             * No description
             *
             * @tags Title
             * @name TitleUpdateTitle
             * @request POST:/v1/identities/{identityId}/profile/updateTitle
             * @secure
             */
            titleUpdateTitle: (identityId, data, params = { withCredentials: true }) => this.request(Object.assign({ path: `/v1/identities/${identityId}/profile/updateTitle`, method: 'POST', body: data, secure: true, type: FecContentType.Json, format: 'json' }, params)),
        };
    }
}
exports.Api = Api;
//# sourceMappingURL=profiles.js.map